import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

const avatarSize = 90;

export default {
  avatar: {
    height: avatarSize,
    width: 'auto',
    borderRadius: 10,
    position: 'relative',
    zIndex: 2,
    flexShrink: 0
  },
  formContainer: {
    borderRadius: 4,
    backgroundColor: appConfig.colors.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 30,
    width: '100%',
    flexShrink: 0,
    [Device.mobile]: {
      boxSizing: 'border-box'
    }
  },
  title: {
    width: '100%',
    textAlign: 'center',
    paddingBottom: 20,
    fontSize: 22
  }
};
